export type FinancialTermLink = {
  label: string;
  url: string;
};

export type FinancialTermItem =
  | { id: string; type: 'text'; content: string }
  | {
    id: string;
    type: 'rich';
    heading: string;
    subheading?: string;
    contentBefore: string;
    link: FinancialTermLink;
    contentAfter: string;
  };

export const FINANCIAL_RESPONSIBILITY_TERMS = {
  title: 'Termo de Responsabilidade — Operações Pix / Conta Bancária',
  intro:
    'Ao cadastrar, gravar ou ativar dados bancários e/ou de integração Pix nesta plataforma,'
    + ' o gestor da franquia declara e concorda que:',
  checkboxLabel:
    'Declaro que revisei meus dados bancários/Pix e concordo com o Termo de Responsabilidade',
  items: [
    {
      id: 'dados-verdadeiros',
      type: 'text',
      content:
        'Os dados bancários, CPF/CNPJ e chave Pix informados são verdadeiros, estão corretos'
        + ' e pertencem à franquia ou a titular autorizado a receber os valores.'
    },
    {
      id: 'manter-atualizados',
      type: 'text',
      content:
        'É de sua exclusiva responsabilidade manter esses dados atualizados, revisar periodicamente'
        + ' as informações cadastradas e comunicar imediatamente qualquer inconsistência.'
    },
    {
      id: 'responsabilidade-processamento',
      type: 'text',
      content:
        'A plataforma processará as operações de pagamento conforme os dados cadastrados.'
        + ' Erros, atrasos ou prejuízos decorrentes de informações incorretas, incompletas'
        + ' ou desatualizadas são de responsabilidade do gestor da franquia.'
    },
    {
      id: 'ciente-taxas',
      type: 'text',
      content:
        'Está ciente das taxas, prazos e condições da instituição financeira'
        + ' e/ou do serviço Pix escolhido.'
    },
    {
      id: 'teste-validacao',
      type: 'rich',
      heading: 'Teste de Validação (Recomendado)',
      contentBefore:
        'Para garantir que tudo está correto, faça um teste enviando um Pix de R$ 0,10'
        + ' (dez centavos) utilizando o sistema ',
      link: {
        label: 'Cliente Web',
        url: 'https://cliente.jumaentregas.com.br/'
      },
      contentAfter:
        '. Acesse seu banco e confirme se o valor caiu na sua conta'
        + ' antes de permitir transações para clientes.'
    },
    {
      id: 'registro-aceite',
      type: 'text',
      content:
        'O aceite deste termo será registrado com data e hora para fins de auditoria e comprovação.'
    }
  ] as FinancialTermItem[]
};
